import { CopyIcon } from '@vk-tech/ui-icons';
import { Input } from '@vk-tech/ui-toolkit';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import styles from './CopyBlock.module.scss';
import { CopyBlockProps } from './CopyBlock.types';

export function CopyBlock({
  text,
  className,
  promocodeApiActions,
  onTargetAction,
}: CopyBlockProps) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<number | null>(null);

  const copyToClipboard = async (value: string) => {
    const targetAction = promocodeApiActions?.['target-action'];

    try {
      await navigator.clipboard.writeText(value);

      setCopied(true);
      timerRef.current = window.setTimeout(() => setCopied(false), 5000);
    } catch (e) {
      console.error(e);
    }

    if (targetAction && onTargetAction)
      onTargetAction(targetAction, false, {
        ymEvent:
          promocodeApiActions?.['data-ui-ym-event'] ??
          promocodeApiActions?.['data-ui-ym-action'],
        tmrEvent: promocodeApiActions?.['data-ui-tmr-event'],
      });
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  const dataAttributes = Object.fromEntries(
    Object.entries(promocodeApiActions || {}).filter(
      ([k]) => k !== 'target-action',
    ),
  );

  return (
    <button
      type="button"
      className={classNames(styles.copyBlock, className)}
      onClick={() => copyToClipboard(text)}
      {...dataAttributes}
    >
      <Input
        value={copied ? 'Промокод скопирован' : text}
        className={styles.input}
        readOnly
        suffix={
          <CopyIcon
            color={
              copied
                ? 'var(--modes-content-system-positive)'
                : 'var(--modes-content-base-primary)'
            }
          />
        }
      />
    </button>
  );
}
